import { Link } from "react-router-dom";
import SelfCertificate from "../Assets/SelfCertificate.pdf"; 

const Section = ({ title, children }) => (
  <div className="mb-12">
    <h3 className="bg-gradient-to-r from-red-600 to-[#ff4e1c] text-white px-4 py-2 font-semibold rounded-t-md">
      {title}
    </h3>
    <div className="border border-red-200 rounded-b-md overflow-hidden">
      {children}
    </div>
  </div>
);

const Row = ({ sl, label, value, link }) => (
  <div className="grid grid-cols-12 border-b last:border-none">
    <div className="col-span-2 bg-red-100 px-3 py-3 font-medium text-gray-800">
      {sl}
    </div>
    <div className="col-span-5 px-3 py-3 text-gray-700">{label}</div>
    <div className="col-span-5 px-3 py-3">
      {link ? (
        <Link
          to={link}
          target="_blank"
          className="text-red-600 font-medium hover:underline"
        >
          View Details
        </Link>
      ) : (
        <span className="text-gray-700">{value}</span>
      )}
    </div>
  </div>
);

export default function Infrastructure() {
  return (
    <>
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold" data-aos="fade-down">
            School Infrastructure
          </h1>
          <p className="mt-3 text-sky-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            Transparency, Compliance & Accountability
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-14">
        <Section title="A: STAFF (TEACHING)">
          <Row sl="1" label="PRINCIPAL" value="1" />
          <Row sl="2" label="TOTAL NO. OF TEACHERS" value="25+" />
          <Row sl="-" label="PGT" value="8" />
          <Row sl="-" label="TGT" value="12" />
          <Row sl="-" label="PRT" value="15" />
          <Row sl="3" label="TEACHER SECTION RATIO" value="1:1.8" />
          <Row sl="4" label="SPECIAL EDUCATOR" value="01" />
          <Row sl="5" label="COUNSELLOR / WELLNESS TEACHER" value="01" />
        </Section>

        <Section title="B: SCHOOL INFRASTRUCTURE">
          <Row sl="1" label="TOTAL CAMPUS AREA" value="8460 Sq. mt."/>
          <Row sl="2" label="TOTAL BUILT-UP AREA" value="2693.51 Sq. mt."/>
          <Row sl="3" label="NUMBER OF CLASSROOMS" value="28"/>
          <Row sl="4" label="NUMBER OF LABORATORIES" value="5"/>
          <Row sl="5" label="INTERNET FACILITY" value="Yes" />
          <Row sl="6" label="NO. OF GIRLS TOILETS" value="10" />
          <Row sl="7" label="NO. OF BOYS TOILETS" value="10" />
        </Section>

        <Section title="C: SELF-CERTIFICATION">
          <Row sl="1" label="SELF-CERTIFICATION PROFORMA" link={SelfCertificate}/>
        </Section>
      </div>
    </>
  );
}


